<div class="few-details maxheight1">
  <nz-row class="title-text text-center addpb processoImg">
    <img class="main_logo" [src]="environment.is_artfine?'../../../assets/images/logo/ArtfineBilzLogo.svg':'../../../assets/images/ProcessoLogo.svg'"/>
  </nz-row>
  <nz-col [nzXs]="{ span: 24 }" [nzLg]="{ span: 16 }" class="fewdetails-box">
    <ng-content></ng-content>
  </nz-col>
</div>
